// This icon file is generated automatically.
var PVerticalRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.1.56h-1a.13.13 0 00-.13.13v10.75c0 .07.06.12.12.12h1c.07 0 .13-.05.13-.12V.69a.13.13 0 00-.13-.13zm6.93 1.13V.56c0-.1-.12-.16-.2-.1L3.23 6l6.6 5.53c.08.07.2.01.2-.1v-1.12a.5.5 0 00-.18-.39L5.18 6l4.67-3.92a.5.5 0 00.18-.39z", "fill-rule": "nonzero" } }] }, "name": "p-vertical-right", "theme": "outlined" };
export default PVerticalRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PVerticalRightOutlined.js
// module id = 3731
// module chunks = 0